.a-tag {
  --btn--padding: 0;
  --btn--mh: none;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: fit-content;
  max-width: 100%;
  flex-shrink: 0;
  gap: var(--fdt-core-spacing-1);
  color: var(--tag--color, var(--fdt-semantic-color-foreground-subtle));
  background-color: var(--tag--bgc, var(--fdt-semantic-color-background-subtle));
  padding: var(--fdt-core-spacing-1) var(--fdt-core-spacing-2);
  border-radius: var(--fdt-semantic-borderradius-tag);
  border: var(--fdt-semantic-borderwidth-default) solid var(--tag--border-color, var(--fdt-semantic-color-border-default));
}
.a-tag.active {
  --tag--color: var(--fdt-semantic-color-foreground-active);
  --tag--border-color: var(--fdt-semantic-color-border-active);
  --tag--bgc: var(--fdt-semantic-color-background-primary-subtle);
}

button.a-tag:hover, button.a-tag.hover,
a.a-tag:hover,
a.a-tag.hover {
  --tag--bgc: var(--fdt-semantic-color-background-subtle-hover);
}
button.a-tag:focus-visible, button.a-tag:active, button.a-tag.active,
a.a-tag:focus-visible,
a.a-tag:active,
a.a-tag.active {
  --tag--color: var(--fdt-semantic-color-foreground-active);
  --tag--border-color: var(--fdt-semantic-color-border-active);
  --tag--bgc: var(--fdt-semantic-color-background-primary-subtle);
}

.a-tag__label {
  line-height: 16px;
}

.a-tag__remove {
  font-size: 0;
}

.a-tag-group {
  display: flex;
  align-items: center;
  gap: var(--fdt-core-spacing-2);
}
.a-tag-group button {
  flex-shrink: 0;
  white-space: nowrap;
}

.a-tag--partial-skeleton {
  color: var(--fdt-button-color-disabled-text);
  pointer-events: none;
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */